module.exports = {"id":"234711","name":"Josip Brekalo","rating":"73","photo":"./data/images/photos/2/234711.png","club":{"name":"VfL Wolfsbourg","logo":"./data/images/clubs/VfLWolfsbourg.png"},"positions":["MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JosipBrekalo0.json
// module id = 2194
// module chunks = 0